var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_989",
    "data-name": "Rectangle 989",
    width: 102,
    height: 102,
    transform: "translate(492 4136)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_restaurent",
    transform: "translate(-492 -4136)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dish_1_",
    "data-name": "dish (1)",
    transform: "translate(493 4137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8234",
    "data-name": "Group 8234",
    transform: "translate(53.338 24.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8233",
    "data-name": "Group 8233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6179",
    "data-name": "Path 6179",
    d: "M273.49,128.668l-1.07-3.522a7.65,7.65,0,0,0-14.487,0l-1.07,3.522a19.783,19.783,0,0,0-.552,9.167,8.622,8.622,0,0,0,4.44,6.009l-1.2,26.79a5.278,5.278,0,0,0,1.333,4.1,5.822,5.822,0,0,0,8.225.369q.192-.176.369-.369a5.207,5.207,0,0,0,1.333-3.992l-1.205-26.9a8.62,8.62,0,0,0,4.434-6.005A19.782,19.782,0,0,0,273.49,128.668Zm-2.732,8.587a5.285,5.285,0,0,1-3.458,3.982,1.666,1.666,0,0,0-1.078,1.635l1.267,28.136a1.928,1.928,0,0,1-.5,1.51,2.575,2.575,0,0,1-3.623,0,2,2,0,0,1-.49-1.62l1.257-28.026a1.667,1.667,0,0,0-1.078-1.635,5.285,5.285,0,0,1-3.458-3.982,16.436,16.436,0,0,1,.458-7.61l1.07-3.523a4.322,4.322,0,0,1,8.107,0l1.07,3.523A16.459,16.459,0,0,1,270.758,137.255Z",
    transform: "translate(-256.012 -119.955)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8236",
    "data-name": "Group 8236",
    transform: "translate(28.335 25.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8235",
    "data-name": "Group 8235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6180",
    "data-name": "Path 6180",
    d: "M152.667,120A1.667,1.667,0,0,0,151,121.667v14.311l-4.512,4.512a1.667,1.667,0,0,0-.488,1.262l1.458,29.168a2.27,2.27,0,0,1-.63,1.7,2.347,2.347,0,0,1-3.319.015l-.015-.015a2.27,2.27,0,0,1-.63-1.7l1.468-29.168a1.667,1.667,0,0,0-.487-1.262l-4.514-4.512V121.667a1.667,1.667,0,0,0-3.333,0v15a1.667,1.667,0,0,0,.488,1.178l4.477,4.479-1.422,28.433a5.63,5.63,0,0,0,11.247.548q.013-.274,0-.548l-1.422-28.433,4.477-4.479a1.667,1.667,0,0,0,.488-1.178v-15A1.667,1.667,0,0,0,152.667,120Z",
    transform: "translate(-136 -120)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8238",
    "data-name": "Group 8238",
    transform: "translate(33.335 25.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8237",
    "data-name": "Group 8237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6181",
    "data-name": "Path 6181",
    d: "M161.667,120A1.667,1.667,0,0,0,160,121.667V135a1.667,1.667,0,1,0,3.333,0V121.667A1.667,1.667,0,0,0,161.667,120Z",
    transform: "translate(-160 -120)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8240",
    "data-name": "Group 8240",
    transform: "translate(38.335 25.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8239",
    "data-name": "Group 8239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6182",
    "data-name": "Path 6182",
    d: "M185.667,120A1.667,1.667,0,0,0,184,121.667V135a1.667,1.667,0,1,0,3.333,0V121.667A1.667,1.667,0,0,0,185.667,120Z",
    transform: "translate(-184 -120)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8242",
    "data-name": "Group 8242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8241",
    "data-name": "Group 8241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6183",
    "data-name": "Path 6183",
    d: "M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0Zm0,96.671A46.669,46.669,0,1,1,96.671,50,46.669,46.669,0,0,1,50,96.671Z",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8244",
    "data-name": "Group 8244",
    transform: "translate(44.609 79.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8243",
    "data-name": "Group 8243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6184",
    "data-name": "Path 6184",
    d: "M224.917,384.454a1.667,1.667,0,0,0-1.821-1.5l-.064.007.007,0a30.617,30.617,0,0,1-7.064,0,1.667,1.667,0,0,0-.388,3.312,33.759,33.759,0,0,0,7.834,0A1.667,1.667,0,0,0,224.917,384.454Z",
    transform: "translate(-214.113 -382.949)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8246",
    "data-name": "Group 8246",
    transform: "translate(70.69 27.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8245",
    "data-name": "Group 8245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6185",
    "data-name": "Path 6185",
    d: "M344.108,134.649a1.666,1.666,0,0,0-2.348-.206l-.007.006a1.667,1.667,0,0,0-.2,2.348,30,30,0,0,1-1.768,40.58,1.667,1.667,0,1,0,2.353,2.362A33.335,33.335,0,0,0,344.108,134.649Z",
    transform: "translate(-339.295 -134.053)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8249",
    "data-name": "Group 8249",
    transform: "translate(37.165 16.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8248",
    "data-name": "Group 8248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8247",
    "data-name": "Group 8247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6186",
    "data-name": "Path 6186",
    d: "M186.36,105.743h0Z",
    transform: "translate(-184.691 -100.385)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6187",
    "data-name": "Path 6187",
    d: "M199.082,80.953a33.63,33.63,0,0,0-19.619,1.205,1.665,1.665,0,1,0,1.168,3.118A30.279,30.279,0,0,1,198.3,84.193a1.667,1.667,0,1,0,.783-3.24Z",
    transform: "translate(-178.382 -80.027)",
    fill: "#f9556d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8251",
    "data-name": "Group 8251",
    transform: "translate(16.665 29.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8250",
    "data-name": "Group 8250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6188",
    "data-name": "Path 6188",
    d: "M92.073,183.972a30,30,0,0,1-3.013-38.815,1.667,1.667,0,0,0-2.665-2l-.029.04a33.335,33.335,0,0,0,3.345,43.139,1.669,1.669,0,0,0,2.362-2.36Z",
    transform: "translate(-79.989 -142.488)",
    fill: "#f9556d"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs1);
export default __webpack_public_path__ + "static/media/ss1.04a5d36bf919ed21d2a1d262d7a08dc8.svg";
export { ForwardRef as ReactComponent };